import type { ApiChild, ApiChildResults, ApiNote, ApiQuestionnaireListItem, Child } from '../types';
import { toChildBase } from './child-base.api';
import { toChildDevelopment } from './child-development.api';
import { toChildNote } from './child-note.api';
import { toChildObservation } from './child-observation.api';

export const toChildDetail = (
  api: ApiChild,
  results: ApiChildResults,
  notes: ReadonlyArray<ApiNote>,
  observations: ReadonlyArray<ApiQuestionnaireListItem>,
  now: number = Date.now(),
): Child => ({
  ...toChildBase(api, now),
  development: toChildDevelopment(results),
  notes: notes.map(toChildNote),
  observations: observations.map(toChildObservation),
});
